<template>
  <div class="yunxiao teacher intention audition">
    <div
      class="intention-communicate-item"
      v-for="(item) in list"
      :key="item.id"
    >
      <div class="circular-point"></div>
      <div class="title">
        {{ app.tool.date.getPassTimeStr(item.createTime)}}
      </div>
      <div class="log-item">
        <div class="types-line">
          安排试听<span style="color:var(--g6);" v-if="item.teacherName">({{item.teacherName}})</span>
        </div>
        <div class="remark-line"><span class="label">试听备注：</span>{{item.remark}}</div>
        <div class="log-content audition-item">
          <div class="line">
            <div class="label">
              试听课：
            </div>
            <div class="content">
              <span v-if="item && item.coursePlanType === 1" style="padding-right: calc(var(--gap) * 4);">
                {{ item && item.curriculumName }}
              </span> 
              <span v-else style="padding-right: calc(var(--gap) * 4);">{{ item && item.className }}</span>
              <span 
                class="tag primary" 
                v-if="item 
                  && item.status>=0 
                  && auditionStatusDesc[item.status]" >{{auditionStatusDesc[item.status]}}</span>
            </div>
          </div>

          <div class="line">
            <div class="label">
              时间：
            </div>
            <div class="content">
              <span>{{ item.startTime | formatDatetime("MM-dd") }}</span>
              <span>（{{item.startTime | getWeek}}）</span>
              <span>
                <span>{{ item.startTime | formatDatetime("hh:mm") }}～</span>
                <span>{{item.endTime | formatDatetime("hh:mm")}}</span> 
              </span>
            </div>
          </div>
          <div class="line">
            <div class="label">
              老师：
            </div>
            <div class="content">
              {{item && item.courseArrangeTeacherName}}
            </div>
          </div>          
          <div class="footer" @click="cancleAudition(item)" v-if="item.status === 0">
            取消试听
          </div>
        </div>
  
        <div 
          class="types-line van-ellipsis" 
          style="margin:calc(var(--gap) * -24)  0 calc(var(--gap) * 26) 0;" 
          v-if="item.intentionClueId">
          来自意向：
          <span style="color:var(--c1);" @click="$router.push('/cluedetails?id='+item.intentionClueId)">
            {{item.intentionClueContent}}
          </span>
        </div>
      </div>
    </div>
    <van-empty
      image="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/empty.png"
      description="当前还没有试听记录"
      v-if="!list||(list&&list.length==0)"
      image-size="128">
    </van-empty>   
  </div>
</template>

<script>

export default {
  name: 'intention-audition',
  props: {
    list: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data () {
    return {
      auditionStatusDesc:{       
        0: '待试听',
        1: '已试听',
        2: '试听失败',
        3: '已取消',
      },
    }
  },
  methods: {
        // 取消试听
    async cancleAudition (item = {}) {
      let {studentId, courseArrangeId, priceItemId, campusId} = item || {};
      
      try {
        let confirmRes = await this.$dialog.confirm({
            message: '是否确定取消学员试听安排？',
        })
        .catch(()=>{
          return false;
        })
        if (confirmRes) {
          this.showLoading();
          let res = await this.$api.auditionCancel({ studentId, courseArrangeId, priceItemId, campusId});
          if (res.code === 200) {
            this.$toast.success('取消试听成功。');
            item.status = 3;
          }
        }

      } catch (err) {
        console.error("取消试听出错", err);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.yunxiao.teacher.intention.audition{
  position: relative;
  margin: calc(var(--gap) * 8) calc(var(--gap) * 16);
  padding: calc(var(--gap) * 8) calc(var(--gap) * 16) calc(var(--gap) * 16) calc(var(--gap) * 21);
  border-radius: calc(var(--gap) * 8);
  background-color: var(--white);
  .intention-communicate-item {
    position: relative;
    padding: 0 0 0 calc(var(--gap) * 16);
    border: 1px solid transparent;
    color: var(--g6);

    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: calc(var(--w) * 24);
      bottom: 0;
      width: 1px;
      background-color: var(--g4);
    }

    &:last-child{
      &::before{
        display: none;
      }
      .circular-point{        
        background-color: var(--g4);
      }
    }
    .circular-point {
      position: absolute;
      top: calc(var(--gap) * 4);
      left: 0;
      width: calc(var(--w) * 10);
      height: calc(var(--w) * 10);
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: var(--c1);
      transform: translate(-50%, 0);
      border-radius: 50%;
      >i{
        font-size:var(--fs-sm);
        color: var(--white);
        transform: scale(0.9);
      }
      &.active{        
        background-color: var(--c4);
      }
      &.audition{
        background-color: var(--c2);
      }
    }
    .title {
      //   margin: 0 0 calc(var(--gap) * 8);
      margin-bottom: calc(var(--gap) * 8);
      margin-left: calc(var(--gap) * 4);
      font-size: var(--fs-sm);
      line-height: var(--lh-sm);
      .next-class {
        padding-left: calc(var(--gap) * 4);
        color: var(--c1);
      }
    }
    &:first-child{
      margin-top: calc(var(--gap) * 12);
    }
  }
  .intention-communicate-item {
    &:last-child{
      &::before{
        display: block;
      }
      .circular-point{        
        background-color: var(--c1);
      }
    }
  }
  .log-item{
    margin: calc(var(--gap) * 16) 0;
    .types-line{
      color: var(--g8);
    }
    .remark-line {
      margin-top: calc(var(--gap) * 4);
      .label {
        color: var(--g8);
      }
    }
    .log-content {
      margin: calc(var(--gap) * 4) 0 calc(var(--gap) * 28);
      padding: calc(var(--gap) * 12);
      border-radius: var(--radius-sm);
      background-color: rgba(var(--c1-rgb), 0.08);
      .line{
        display: flex;
        .content{
          flex: 1;
        }
        .label{
          white-space: nowrap;
          flex-shrink: 0;
        }
      }
    }
    .audition-item{
      overflow: hidden;
      padding: calc(var(--gap) * 12) 0 0;
      >div{        
        padding: 0 calc(var(--gap) * 12);
      }
      >div.line:last-child{
        margin-bottom: calc(var(--gap) * 12);
      }
      .tag{
        display: inline;
        white-space: nowrap;
      }
      .footer{
        margin-top: calc(var(--gap) * 10);
        display: flex;
        height: calc(var(--w) * 32);
        align-items: center;
        justify-content: center;
        color:var(--c1);
        font-size:var(--fs-sm);
        line-height:var(--lh-sm);
        font-weight: var(--bold);
        border-top: 1px solid var(--g3);
      }
    }
    .con {
      margin-top: calc(var(--gap) * 8);
      &:first-child {
        margin-top: 0;
      }
      .point {
        color: var(--g8);
      }
 
    }
    .tag {
      padding: 0 calc(var(--gap) * 4);
      display: inline-block;
      color: var(--g5);
      font-size:var(--fs-sm);
      
      color: var(--c1);
      border-radius: 2px;
      border: 1px solid var(--c1);
      &:not(:last-child){
        margin-right: calc(var(--gap) * 8);
      }
    }
  }
}
</style>